import React from "react";
import { MonitoringAdviceCard } from "../../monitoring/MonitoringAdviceCard";
import { GeneralAdviceCard } from "../../monitoring/GeneralAdviceCard";

interface NutritionMonitoringTabProps {
  appointmentId: string;
  isCompleted?: boolean;
}

export const NutritionMonitoringTab: React.FC<NutritionMonitoringTabProps> = ({
  appointmentId,
  isCompleted = false,
}) => {
  return (
    <div className="space-y-4">
      <MonitoringAdviceCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="nutrition"
      />
      <GeneralAdviceCard
        appointmentId={appointmentId}
        isCompleted={isCompleted}
        parentType="nutrition"
      />
    </div>
  );
};
